import { VectorLayer } from './Layer';
import { DevDataService } from '../model/DevDataService';
import { outlineRegion, outlineRegionLow } from './MapVectorStyles.js';
import { useEffect, useState } from 'react';
import { convertGeometryToFeatures } from '../controller/LayerQueries';

const HighlightRegionLayer = (props) => {
    const { map, zoom, zIndex, reportLoadStatus = () => {}, downloadRegion } = props;
    const [features, setFeatures] = useState([]);
    const [loadStatus, setLoadStatus] = useState(1);
    const [detail, setDetail] = useState('low');

    const stateFeatures = async () => {
        const DS = new DevDataService();
        return DS.getGeometryData({ scope: 'state' })
            .then((data) => data[0])
            .then((json) => {
                const shapes = convertGeometryToFeatures(json, 'topojson');
                return shapes.map((f) => {
                    f.set('regionSlug', 'S_' + f.get('STATEFP'));
                    return f;
                });
            });
    };
    const hhsFeatures = async () => {
        const DS = new DevDataService();
        return DS.getGeometryData({ type: 'geometry', scope: 'hhs' }).then((json) => {
            const shapes = convertGeometryToFeatures(json[0], 'topojson');
            return shapes.map((f) => {
                f.set('regionSlug', 100 + f.get('HHSRegID'));
                return f;
            });
        });
    };

    const fetchGeometry = async () => {
        setLoadStatus(0);
        const states = stateFeatures();
        const hhsRegions = hhsFeatures();
        const shapes = (await Promise.all([states, hhsRegions])).flat();
        styleFeatures(shapes);
        setFeatures(shapes);
        setLoadStatus(1);
    };
    const styleFeatures = (shapes) => {
        for (let shape of shapes) {
            if (downloadRegion === shape.get('regionSlug')) {
                shape.setStyle(detail === 'high' ? outlineRegion : outlineRegionLow);
            } else {
                shape.setStyle(null);
            }
        }
    };

    useEffect(() => reportLoadStatus(loadStatus), [loadStatus]);
    useEffect(() => map && fetchGeometry(), [map]);
    useEffect(() => map && setDetail(zoom > 6 ? 'high' : 'low'));
    useEffect(() => styleFeatures(features), [detail, downloadRegion]);

    return <VectorLayer title={'States'} style={null} features={features} zIndex={zIndex} map={map} />;
};
export { HighlightRegionLayer };
